export default "__VITE_ASSET__D6R9l$RQ__"